import { InjectionToken } from '@angular/core';
import { ProfileGateway } from './profile-gateway.interface';

export const PROFILE_GATEWAY = new InjectionToken<ProfileGateway>(
  'profile-gateway',
);
